import { useEffect } from 'react'

import { WidgetTourActionHandler } from '../models'
import { widgetTourActionRegistry } from '../shared/widgetTourActionRegistry'

export const useWidgetTourActionHandler = (
  widgetId: string,
  handler: WidgetTourActionHandler
): void => {
  useEffect(() => widgetTourActionRegistry.register(widgetId, handler), [handler, widgetId])
}
